import { render, staticRenderFns } from "./Linkage.vue?vue&type=template&id=4e6b3eb3&scoped=true"
import script from "./Linkage.vue?vue&type=script&lang=js"
export * from "./Linkage.vue?vue&type=script&lang=js"
import style0 from "./Linkage.vue?vue&type=style&index=0&id=4e6b3eb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6b3eb3",
  null
  
)

export default component.exports